<template>
  <div class="container">
    <b-row>
      <div class="col-6">
        <div class="ld-card-header">
          <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
          <img src="@/assets/images/logos/logo.svg" v-else alt="logo" class="logo-modal" style="max-height: 50px;">
        </div>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end">
        <div class="noPrint">
          <button class="btn btn-outline-primary btn-xs " @click="$emit('print')" v-b-tooltip.hover :title="$gettext('print')">
            <b-icon icon="file-earmark-text" />
          </button>
          <button class="btn btn-outline-danger btn-xs mx-2" @click="$emit('download')" v-b-tooltip.hover :title="$gettext('PDF')">
            <b-icon icon="download" />
          </button>
          <button class="btn btn-outline-info btn-xs " @click="$emit('closeModal')" v-b-tooltip.hover :title="$gettext('Close')">
            <b-icon icon="x" />
          </button>
        </div>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'
export default {
  name: 'modalHeader',
  mixins: [authMixin]
}
</script>
